var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoRealname = function SvgHospitalinfoRealname(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M17 10h-2V7c0-.55.45-1 1-1s1 .45 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M26 10H6v15h20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M25 11H7v13h18z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6726"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21.25c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M23 14.63h-6v.75h6zM23 17.13h-6v.75h6zM23 19.63h-6v.75h6z"
  })));
};
export default SvgHospitalinfoRealname;